'use client'

import { Supplier } from '@/types/Supplier'
import s from './supplier-enquiry-form-success.module.scss'
import Link from 'next/link'
import { mapSupplierToCardProps } from '@/utils/mapSupplierToCardProps'
import { CSS_BREAKPOINTS_V2 } from '@/constants'
import { ButtonV4 } from '@/components/v4/atoms/button/button'
import { SendMsgIcon } from '@/components/svg/send-msg-icon/send-msg-icon'
import { XIconNew } from '@/components/svg/x-icon-new/x-icon-new'
import { VisibleOn } from '@/components/v3/atoms/visible-on'
import { useRouter } from 'next/navigation'
import { SliderWithNavigation } from '@/components/v3/molecules/custom-sliders/slider-with-navigation/slider-with-navigation'
import Card from '@/components/v3/atoms/card/card'

type Props = {
  relatedSuppliers: Supplier[]
  supplierTitle: string
  supplierSlug: string
  handleCancelBtn?: () => void
}

export const SupplierEnquiryFormSuccess = ({
  relatedSuppliers,
  supplierTitle,
  supplierSlug,
  handleCancelBtn,
}: Props) => {
  const mappedSuppliers = mapSupplierToCardProps(relatedSuppliers)
  const router = useRouter()

  return (
    <div className={s.container}>
      <div className={s.content}>
        <h2 className={s.title}>Thank you!</h2>
        <p className={s.description}>
          Your message has been sent to the{' '}
          <Link href={supplierSlug}>{supplierTitle}</Link>. They will be in
          touch with you shortly.
        </p>
        {mappedSuppliers && mappedSuppliers.length > 0 && (
          <div className={s.sliderContainer}>
            <SliderWithNavigation
              title={<h3 className={s.sliderTitle}>Explore suppliers nearby</h3>}
              navigationPosition="right"
              navigationIconsColor="#fff"
              topWrapperClassName={s.sliderTopWrapper}
              sliderArrowClassName={s.sliderArrowClassName}
              keenSliderOptions={{
                breakpoints: {
                  [`(min-width: ${CSS_BREAKPOINTS_V2.tablet})`]: {
                    slides: {
                      spacing: 20,
                      perView: 2.5,
                    },
                  },
                  [`(min-width: ${CSS_BREAKPOINTS_V2.desktopS})`]: {
                    slides: {
                      spacing: 20,
                      perView: 2,
                    },
                  },
                },
                slides: {
                  perView: 1.5,
                  spacing: 20,
                },
              }}
            >
              {mappedSuppliers?.map((item) => {
                return (
                  <div key={`${item.id}-slider`}>
                    <Card
                      primaryColor={'#fff'}
                      reverseVertical
                      size="Small"
                      adjustToSlider
                      itemId={item.id!}
                      header={item.title}
                      path={item.path}
                      date={item.date}
                      category={item?.category || ''}
                      locations={item.locations}
                      type={'Supplier'}
                      imageUrl={item.imageUrl!}
                      imageAlt={item.imageAlt!}
                    />
                  </div>
                )
              })}
            </SliderWithNavigation>
          </div>
        )}
      </div>

      <VisibleOn desktop>
        <ButtonV4
          onClick={() => {
            router.push(`${supplierSlug || ''}`, {
              scroll: false,
            })
          }}
          className={s.sendAnotherMessageBtn}
        >
          SEND ANOTHER MESSAGE
          <SendMsgIcon
            svgProps={{
              className: s.sendMsgIcon,
            }}
          />
        </ButtonV4>
      </VisibleOn>

      {handleCancelBtn && (
        <ButtonV4
          className={s.cancelBtn}
          type="button"
          onClick={handleCancelBtn}
        >
          <XIconNew />
          &nbsp;Close
        </ButtonV4>
      )}
    </div>
  )
}
